<div class="horizontalScroll px-4">
  <button class="horizontalScroll_btn horizontalScroll_btn--left" (click)="scrollLeft()" data-testId="sub-tab-previous">
    <div class="mat-mdc-tab-header-pagination-chevron"></div>
  </button>

  <div class="horizontalScroll_area py-1 my-n1" #content (cdkObserveContent)="observeContentChange()">
    <!-- Make sure the content has flex-wrap: nowrap -->
    <ng-content></ng-content>
  </div>

  <button class="horizontalScroll_btn horizontalScroll_btn--right" (click)="scrollRight()" data-testId="sub-tab-next">
    <div class="mat-mdc-tab-header-pagination-chevron"></div>
  </button>
</div>
